import React from 'react';
import { LinkButton } from 'app/blocks/buttons/buttons';
import SvgIcon from 'app/blocks/common/svg-icon/svg-icon';
import withProfileUrl from 'app/blocks/common/withProfileUrl';
import './profile-link.scss';

const Icon = ({ error, url }) => (
    <>
        {url && !error && <SvgIcon.account_circle />}
        {!url && !error && <SvgIcon.loading className="svg-icon-loading" iconTitle="Profile url loading" />}
        {error && <SvgIcon.error className="svg-icon-error" iconTitle="Cannot link account page" />}
    </>
);

const ProfileLink = ({ error, goToLogin, isAuth, texts, url }) => {
    return (
        <>
            {isAuth && (
                <LinkButton
                    className="mobileMenu-item ProfileLink"
                    data-seleniumid="menu-profile-btn"
                    disabled={!url}
                    href={url}
                    isLinkTag
                    rel="noreferrer"
                    role="menuitem"
                    target="_blank"
                >
                    <Icon error={error} url={url} />
                    {texts.profile}
                </LinkButton>
            )}
            {!isAuth && (
                <button
                    className="mobileMenu-item ProfileLink"
                    data-seleniumid="mobile-menu-login-btn"
                    onClick={goToLogin}
                    role="menuitem"
                    type="button"
                >
                    <Icon error={error} url={url} />
                    {`${texts.login} / ${texts.register}`}
                </button>
            )}
        </>
    );
};

export default withProfileUrl(ProfileLink);
export { ProfileLink };
